import { useState, useRef } from 'react';
import { Popover, MenuItem, MenuList, withStyles } from '@material-ui/core';
import Tooltip from '../../../../../../../common/StyledToolTip';
import { ToggleButtonGroup as ButtonGroup, ToggleButton as Button } from '@material-ui/lab';
import { ArrowDropDown as ArrowDropDownIcon, CheckOutlined as DoneIcon } from '@material-ui/icons';
import { PICKUP_ASSIGNMENT_TYPE } from '../constants';
import RecommendationConfirmationDialog from './RecommendationConfirmationDialog';
import { getAssignRecommendationType } from './utils';

const styles = (theme) => ({
  buttonContainer: {
    border: `1px solid ${theme.HeaderSelectedText}`
  },
  yesButton: {
    background: theme.HeaderSelectedText,
    height: 24,
    '&:hover': {
      backgroundColor: theme.HeaderSelectedText
    },
    minWidth: 32,
    width: 32
  },
  yesIcon: {
    color: 'white'
  },
  expandButton: {
    background: 'white',
    height: 24,
    '&:hover': {
      backgroundColor: 'white'
    },
    minWidth: 19,
    width: 19
  },
  expandIcon: {
    color: theme.HeaderSelectedText
  },
  menu: {
    padding: 0
  },
  menuItem: {
    fontSize: theme.headerTextFontSize,
    lineHeight: '14px',
    color: theme.TextColor,
    padding: '4px 12px',
    "&:hover": {
      background: theme.customMultiSelectColor,
    },
  },
  popoverPaper: {
    backgroundColor: theme.ModalBGColor,
  },
});

const AssignReassignRecommendedDrivers = ({ classes, runCommand }) => {
  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);
  const [pickupAssignmentType, setPickupAssignmentType] = useState(null);

  const handleRecommendationClick = (assignmentType) => {
    setPickupAssignmentType(assignmentType);
  };

  const handleToggleMenu = (event) => {
    anchorRef.current = event.currentTarget;
    setOpen((prevOpen) => !prevOpen);
  };

  const handleMenuClose = () => {
    setOpen(false);
  };

  const closeConfirmationDialog = () => {
    setPickupAssignmentType(null);
    handleMenuClose();
  };

  const assignAndReassignRecommendedDrivers = () => {
    runCommand('AcceptRecommendations', { pickupAssignmentType });
    closeConfirmationDialog();
  };

  const getConfirmationDialogProps = () => {
    const typeDetails = getAssignRecommendationType(pickupAssignmentType);
    const isInValidSelection = runCommand('isInValidPickupSelectionForRecommendation', {pickupAssignmentType});
    if (isInValidSelection) {
      typeDetails.description = typeDetails.subDescription
    }
    typeDetails.isInValidSelection = isInValidSelection
    return typeDetails;
  }

  return (
    <>
      <ButtonGroup className={classes.buttonContainer}>
        <Tooltip title="Assign selected drivers">
          <Button
            onClick={() => handleRecommendationClick(PICKUP_ASSIGNMENT_TYPE.assignSelected)}
            classes={{
              root: classes.yesButton
            }}>
            <DoneIcon className={classes.yesIcon} />
          </Button>
        </Tooltip>
        <Button
          onClick={handleToggleMenu}
          classes={{
            root: classes.expandButton
          }}
          ref={anchorRef}>
          <ArrowDropDownIcon className={classes.expandIcon} />
        </Button>
      </ButtonGroup>
      <Popover
        open={open}
        anchorEl={anchorRef.current}
        onClose={handleMenuClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
        classes={{
          paper: classes.popoverPaper,
        }}>
        <MenuList autoFocusItem className={classes.menu}>
          <MenuItem
            key={PICKUP_ASSIGNMENT_TYPE.assignAll}
            className={classes.menuItem}
            onClick={() => handleRecommendationClick(PICKUP_ASSIGNMENT_TYPE.assignAll)}>
            {PICKUP_ASSIGNMENT_TYPE.assignAll}
          </MenuItem>
        </MenuList>
      </Popover>
      {pickupAssignmentType && (
        <RecommendationConfirmationDialog
          {...getConfirmationDialogProps()}
          onCancel={closeConfirmationDialog}
          onConfirm={assignAndReassignRecommendedDrivers}
        />
      )}
    </>
  );
};

export default withStyles(styles)(AssignReassignRecommendedDrivers);
